import { Landmark, Phone, Mail, MapPin } from "lucide-react";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { waLink, WA_DEFAULT_MSG, WHATSAPP_DISPLAY } from "@/lib/whatsapp";

const OFFICES = [
  {
    city: "Delhi",
    address: "Unit 1701, 17th Floor, RG Trade Tower, Netaji Subhash Place, Pitampura, Delhi - 110034",
  },
  {
    city: "Tinsukia, Assam",
    address: "Manav Kalyan, Namghar Road, Tinsukia, Assam - 786125",
  },
];

export const Footer = () => (
  <footer className="bg-forest-dark text-bone/80">
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-14 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
      <div>
        <div className="flex items-center gap-2">
          <Landmark className="h-6 w-6 text-bronze-light" />
          <span className="font-serif text-2xl font-medium text-bone">
            Rajkiran <span className="text-bronze-light">Wealth</span>
          </span>
        </div>
        <p className="mt-4 text-sm max-w-xs">
          Honest, personal advice across mutual funds, fixed income, and term insurance.
        </p>
      </div>

      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-bronze-light">Explore</p>
        <ul className="mt-4 space-y-2 text-sm">
          <li><a href="#services" data-testid="footer-link-services" className="hover:text-bone transition-colors">Services</a></li>
          <li><a href="#about" data-testid="footer-link-about" className="hover:text-bone transition-colors">About your advisor</a></li>
          <li><a href="#faq" data-testid="footer-link-faq" className="hover:text-bone transition-colors">FAQ</a></li>
          <li><a href="#contact" data-testid="footer-link-contact" className="hover:text-bone transition-colors">Get a call back</a></li>
        </ul>
      </div>

      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-bronze-light">Talk to us</p>
        <a
          href={waLink(WA_DEFAULT_MSG)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-whatsapp-link"
          className="mt-4 inline-flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-2.5 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5"
        >
          <WhatsAppIcon className="h-4 w-4" />
          WhatsApp Us
        </a>
        <a
          href="tel:+919953198325"
          data-testid="footer-phone-link"
          className="mt-4 flex items-center gap-2 text-sm hover:text-bone transition-colors"
        >
          <Phone className="h-4 w-4 shrink-0 text-bronze-light" />
          Call Us — {WHATSAPP_DISPLAY}
        </a>
        <a
          href="mailto:Jinendra0910@gmail.com"
          data-testid="footer-email-link"
          className="mt-2 flex items-center gap-2 text-sm hover:text-bone transition-colors"
        >
          <Mail className="h-4 w-4 shrink-0 text-bronze-light" />
          Jinendra0910@gmail.com
        </a>
      </div>

      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-bronze-light">Visit us</p>
        <ul className="mt-4 space-y-4">
          {OFFICES.map((o) => (
            <li key={o.city} data-testid={`footer-office-${o.city.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="flex gap-2 text-sm">
              <MapPin className="h-4 w-4 mt-0.5 shrink-0 text-bronze-light" />
              <span>
                <span className="font-semibold text-bone">{o.city}</span>
                <br />
                {o.address}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>

    <div className="border-t border-bone/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 space-y-2">
        <p className="text-xs text-bone/50">
          Mutual fund investments are subject to market risks. Read all scheme related documents
          carefully before investing. Insurance is the subject matter of solicitation.
        </p>
        <p className="text-xs text-bone/50">
          © {new Date().getFullYear()} Rajkiran Wealth. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);
